// extracted by mini-css-extract-plugin
module.exports = {"page":"Course_page__KjDlg","container":"Course_container__ETlnQ","sep":"Course_sep__1QRhJ","courseDetails":"Course_courseDetails__2vFiJ","memberInfo":"Course_memberInfo__1KgFe"};